import { useLocalizationExtension } from '../../../context/Localization/localization';
import { PhoneFieldValidationProps } from './PhoneFieldValidation.type';
import * as Yup from 'yup';

/**
 * This funciton handles the phone validation for the useField formik validator.
 *
 * @param name - {@link PhoneFieldValidationProps.name name} description.
 * @param label - {@link PhoneFieldValidationProps.label label} description.
 * @param required - {@link PhoneFieldValidationProps.required required} description.
 */
const PhoneFieldValidation = ({
    name,
    label,
    required,
}: PhoneFieldValidationProps) => {
    const { formatRequired, phoneInvalid } = useLocalizationExtension();

    return async (value: string) => {
        const formattedValue: string = value.replace(/[^\d]/g, '');

        if (required && (!formattedValue || formattedValue.length < 1)) {
            return formatRequired(label || name);
        }
        else if (formattedValue.length !== 10 || !Yup.string()
            .phone()
            .isValidSync(formattedValue)) {
            return phoneInvalid;
        }

        return undefined;
    };
};

export default PhoneFieldValidation;